import DownloadAppPopComponent from './DownloadAppPop.vue'

let $vm

export default {
    install (Vue) {
        const DownloadAppPop = Vue.extend(DownloadAppPopComponent)

        if (!$vm) {
            $vm = new DownloadAppPop({el: document.createElement('div')})
            document.body.appendChild($vm.$el)
        }

        Vue.$downapppop = {
            open (word) {
                $vm.open(word)
            },
            close () {
                $vm.close()
            }
        }

        Vue.mixin({
            created () {
                this.$downapppop = Vue.$downapppop
            }
        })
    }
}
